export default "__VITE_ASSET__Bmsrc3bI__"